"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class HasLengthValidator {
    constructor(options) {
        this.options = options;
    }
    isValid(input) {
        if (typeof input === "undefined" || input === null) {
            return false;
        }
        return validatorJS.isLength(input, this.options);
    }
}
exports.HasLengthValidator = HasLengthValidator;
//# sourceMappingURL=HasLengthValidator.js.map